module.exports = __webpack_public_path__ + "static/img/5.1b43a3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/5.png
// module id = jVqb
// module chunks = 0